// extracted by mini-css-extract-plugin
export default {"buttonLink":"linkPersonalizado9_buttonLink__+r3ad"};